import { validator } from "@/utils/validator";

export const companyBranchImportCsvSchema = validator.object().shape({
  file: validator.mixed().isCsvFile().label("CSVファイル").required(),
  dataFormat: validator.string().isSelection().trim().emptyToNull().label("データ様式").required(),
  firstRowSpecification: validator.string().isSelection().trim().emptyToNull().label("先頭行の仕様").required(),
  characterCode: validator.string().isSelection().trim().emptyToNull().label("文字コード").required(),
  delimiter: validator.string().isSelection().trim().emptyToNull().label("区切り文字").required(),
});
